import { createContext } from 'react';
import i18n, { defaultLanguage } from 'src/i18n';

const translate = (key: string, options?: any) => {
    const result = i18n.t(key, { returnObjects: true, ...options });

    if (typeof result === 'string') return result;

    if (Array.isArray(result)) return result;

    return undefined; // ✅ IMPORTANT (pas key, pas function)
};

const createProxy = (path = ''): any => {
    return new Proxy({}, {
        get: (_, key: string) => {
            if (typeof key === 'symbol') {
                if (key === Symbol.toPrimitive) {
                    return () => translate(path);
                }
                return undefined;
            }

            if (key === 'toString' || key === 'valueOf' || key === 'toJSON') {
                return () => translate(path);
            }

            const newPath = path ? `${path}.${key}` : key;

            const result = translate(newPath);

            // ✅ IMPORTANT: si c'est string ou array → retourne DIRECTEMENT
            if (typeof result === 'string' || Array.isArray(result)) {
                return result;
            }

            return createProxy(newPath);
        }
    });
};

const dictionary = createProxy();

export interface ILocalizationContext {
    strings: any;
    lang: string;
    tArray: (key: string) => string[];
}

const LocalizationContext = createContext<ILocalizationContext>({
    strings: dictionary,
    lang: defaultLanguage,
    tArray: () => [],
});

export default LocalizationContext;
export { dictionary };
